import React, { useEffect } from 'react';
import { VisibleForFields } from 'app/components/visible-for-fields';
import { endpoints } from 'app/area/codetable/item/endpoints';
import styles from './code-exclude.scss';
import { getValidationWithoutDuplicates } from 'app/area/codetable/item/code-pickers/helpers';
import { isDefinedIncludingZero } from 'app/infrastructure/data/number';
import { CodeExcludeProps } from 'app/area/codetable/item/code-fields/types';
import { getDisabledOptions } from 'app/area/codetable/item/code-fields/get-disabled-options';
import { CodeComplexValue } from 'app/area/shared/codetable/types';

export const CodeExclude = (props: CodeExcludeProps) => {

  const { codeItem, originalCodeItem, metadata, onChange, options, loadOptions, translation, codetableId, validation, readOnly } = props;

  if (!metadata || !metadata.features || !metadata.features.visible) {
    return null;
  }

  useEffect(() => {
    if (!isDefinedIncludingZero(codetableId)) {
      return;
    }

    loadOptions('excludableFields', endpoints.excludableFields(codetableId), undefined);
  }, [codetableId]);

  const excludableFieldsOptions = (!!options && !!options.excludableFields && options.excludableFields.codes
    || []) as CodeComplexValue<number>[];

  const fetching = !!options && !!options.excludableFields && options.excludableFields.fetching;

  const disabledOptions = getDisabledOptions(originalCodeItem, excludableFieldsOptions);

  const excludeValidation = !!validation && !!validation.exclude ? getValidationWithoutDuplicates(validation.exclude) : undefined;

  const invalidOptionIds = !!excludeValidation ? excludeValidation.messages.map(message =>
    !!message.parameters && isDefinedIncludingZero(message.parameters.id) ? message.parameters.id : undefined) : [];

  const invalidOptions = !!excludableFieldsOptions && [...disabledOptions, ...excludableFieldsOptions].filter(option =>
    invalidOptionIds.some(id => id === option.value));

  return <div className={styles.clearRows}>
    <div className={`control-label ${styles.codeExcludeLabel}`}>
      {translation.visible_for_fields}
    </div>
    <VisibleForFields
      onChange={onChange}
      options={excludableFieldsOptions}
      fetching={fetching}
      invalidOptions={invalidOptions}
      onEmptyOptions={<div className={`${styles.noOptionsFound} no-content`}>{translation.no_options_found}</div>}
      readOnly={readOnly}
      valueItems={codeItem && codeItem.excludeFields}
      initialValueItems={disabledOptions}
      validation={excludeValidation}
      loadingText={translation.loading}
    />
  </div>;
};
